import { TransformedCustomViewContainer } from "../../components/transformed_custom_view";
import { PivotControl } from "../../constants/pivot_control_options";
import { defaultConfig } from "./default_config";
import { paramsToTransformArgs } from "./params_to_transform_args";
import { DatePivotParams } from "../../entities/date_pivot_params";
import { defaultChartViewerConfig } from "./default_chart_viewer_config";
import { createInventoryHealthForHubsMatrix } from "../../utils/inventory_health_for_hubs_matrix";

/**
 * Cora combined Inventory + WOS view.
 *
 * Reads supply_walk_cora (hub + spoke + hub_spoke + in_transit union), so:
 * - segmenting by SKU sums physical inventory across all roles (in-transit
 *   units included) and WOS covers end-customer demand only;
 * - segmenting by location keeps each role's own walk and per-role WOS
 *   (hub coverage includes transfer departures, matching Inventory Health);
 * - the location_role column filters hub vs spoke rows (hub_spoke = both).
 * Collapsed group row = the selected measure (defaults to inventory on
 * hand); expanding reveals the WOS rows.
 */
export const InventoryWosCoraContainer = () => {
  const dateHierarchyColumnFilter = {
    week: "week",
    month: "month",
    day: "day",
  };

  // Hardcoded measure options for the dropdown; rank order matches the
  // transform's measure_defs (rank 1 = inventory on hand).
  const measureColumnFilter = (params: DatePivotParams) => {
    const dateHierarchy =
      params.dateHierarchy.charAt(0).toUpperCase() +
      params.dateHierarchy.slice(1) +
      "s";
    return {
      "Inventory": "Inventory",
      [`${dateHierarchy} of Supply`]: `${dateHierarchy} of Supply`,
      [`Target ${dateHierarchy} of Supply`]: `Target ${dateHierarchy} of Supply`,
    };
  };

  return (
    <TransformedCustomViewContainer
      viewControllerConfig={{
        datasetName: "supply_walk_cora",
        transformId: "inventory_wos_cora",
        folder: "outputs",
        title: "Inventory",
        dateHierarchyColumnFilter,
        excludedSegmentationsFilter: ["discontinued_date", "active"],
        measureColumnFilter,
        excludedFilterColumnFilter: [],
        showControls: [
          PivotControl.DateHierarchy,
          PivotControl.SegmentSelectMulti,
          PivotControl.FilterBy,
          PivotControl.DatePeriodPicker,
          PivotControl.Measure,
          PivotControl.ShowSettings,
          PivotControl.StoreAsDefault,
          PivotControl.EnableChartView,
          PivotControl.Download,
        ],
        paramsToTransformArgs,
        getMatrix: createInventoryHealthForHubsMatrix,
        chunkedMatrixTransformId: "inventory_wos_cora_matrix",
        excludeDetailRows: true,
      }}
      defaultConfig={defaultConfig}
      chartConfig={defaultChartViewerConfig}
    />
  );
};
